import { render, staticRenderFns } from "./doctorvipmanage.vue?vue&type=template&id=6fd77df9&"
import script from "./doctorvipmanage.vue?vue&type=script&lang=js&"
export * from "./doctorvipmanage.vue?vue&type=script&lang=js&"
import style0 from "./doctorvipmanage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports